import React from "react"
import { SvgIconProps } from "./Home"

const SvgMoreOptionsIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="5"
    fill="none"
    viewBox="0 0 21 5"
  >
    <circle cx="2.5" cy="2.5" r="2.5" fill={fill ?? "#C4C4C4"}></circle>
    <circle cx="10.5" cy="2.5" r="2.5" fill={fill ?? "#C4C4C4"}></circle>
    <circle cx="18.5" cy="2.5" r="2.5" fill={fill ?? "#C4C4C4"}></circle>
  </svg>
)
export default SvgMoreOptionsIcon
